import React, { PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import { Translation, Locale } from 'locale'
import { MultiButton, MultiButtonProps } from './MultiButton'
import { ButtonStrip, ButtonStripProps } from './ButtonStrip'
import { Tooltip } from '../tooltip'
import * as constants from 'view/styles/constants'

interface ToggleButtonProps {
  id?: string
  tooltip: Translation
  onToggle: () => unknown
  on: boolean
  disabled?: boolean
  dataTestId?: string
}

interface ToggleProps extends MultiButtonProps {
  on: boolean
}

export const Toggle = styled(MultiButton)<ToggleProps>`
  width: 32px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  opacity: ${props => (props.disabled ? '0.33' : '1')};
  background-color: ${props => (props.on ? constants.ACCENT_PRIMARY : constants.CORE_PRIMARY)};
  color: ${props => (props.on ? constants.CORE_PRIMARY : constants.CORE_PRIMARY_7)};

  svg {
    width: 14px;
    height: 14px;
  }
  &:hover {
    background-color: ${constants.ACCENT_PRIMARY_1};
    color: white;
  }
`

export const ToggleButtonStrip = styled(ButtonStrip)<ButtonStripProps>`
  margin-left: 5px;
  &:first-child {
    margin-right: 0;
  }

  & > * {
    border-radius: 0;
  }
  & > *:not(:last-child) {
    margin-right: 1px;
  }
  & > *:first-child {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  & > *:last-child {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  & > *:only-child {
    margin: 0;
  }
`

export const ToggleButton = React.forwardRef<HTMLElement, PropsWithChildren<ToggleButtonProps>>((props, ref) => {
  const { id, tooltip, onToggle, on, disabled, children, dataTestId } = props
  return (
    <Tooltip key={tooltip} tooltip={Locale.translate(tooltip)}>
      <Toggle ref={ref} id={id} dataTestId={dataTestId} on={on} disabled={disabled} onClick={onToggle}>
        {children}
      </Toggle>
    </Tooltip>
  )
})
